/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-syntax */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { TextField, MenuItem } from '@material-ui/core';
import useWindowDimensions from '../../hooks/useWindowDimensions';

const AutomaticTestDialog = props => {
  const automaticTestCloseReasons = useSelector(state => state.tasks.automaticTestCloseReasons);
  const automaticTestResults = useSelector(state => state.tasks.automaticTestResults);
  const [closeNote, setCloseNoteValue] = useState(null);

  let upStreamData = {};
  let downStreamData = {};
  let commonTestResultData = null;

  const [automaticTestReasonId, setAutomaticTestReasonId] = useState(null);
  const { width } = useWindowDimensions();
  const fontSize = width <= 500 ? '4vw' : '20px';
  const cellStyle = {
    backgroundColor: '#e5e4e2',
    resize: 'both',
    width: '20px',
    fontSize,
    padding: '4px',
  };
  const rowStyle = { lineHeight: '0.5px' };
  if (automaticTestResults.length > 0) {
    for (let i = 0; i < automaticTestResults.length; i++) {
      const testResult = automaticTestResults[i];
      if (testResult.isDocsis) {
        const docsisResult = testResult.docsisRedResult[0];

        if (docsisResult.upStream !== null) {
          upStreamData = docsisResult.upStream[0];
        }
        if (docsisResult.downStream !== null) {
          downStreamData = docsisResult.downStream[0];
        }
      }
      if (!testResult.isDocsis) {
        const { commonDeviceRedResult } = testResult;

        if (commonDeviceRedResult !== undefined) {
          commonTestResultData = testResult.commonDeviceRedResult;
        }
      }
    }

    const upStreamHeaderColumns = [
      <TableCell style={{ ...cellStyle }} component="th" scope="row" />,
    ];
    const downStreamHeaderColumns = [
      <TableCell style={{ ...cellStyle }} component="th" scope="row" />,
    ];
    const upStreamTableData = [];
    const downStreamTableData = [];

    if (Object.keys(upStreamData).length > 0) {
      const tableColumns = Object.keys(upStreamData).length;
      const tableRows = upStreamData[Object.keys(upStreamData)[0]].length;

      for (let headerRowCount = 0; headerRowCount < tableColumns; headerRowCount++) {
        upStreamHeaderColumns.push(
          <TableCell style={{ ...cellStyle }} component="th" scope="row">
            {Object.keys(upStreamData)[headerRowCount]}
          </TableCell>
        );
      }

      for (let tableRowCount = 0; tableRowCount < tableRows; tableRowCount++) {
        const tableCells = [];

        tableCells.push(
          <TableCell align="left" style={{ ...cellStyle, backgroundColor: undefined }}>
            {upStreamData[Object.keys(upStreamData)[0]][tableRowCount].interface}
          </TableCell>
        );

        for (let i = 0; i < tableColumns; i++) {
          const rowData = upStreamData[Object.keys(upStreamData)[i]][tableRowCount];

          if (rowData !== undefined) {
            tableCells.push(
              <TableCell
                align="left"
                style={{ ...cellStyle, backgroundColor: undefined, color: rowData.color }}
              >
                {rowData.integerValue}
              </TableCell>
            );
          }
        }
        if (tableCells.length > 0) {
          upStreamTableData.push(<TableRow style={rowStyle}>{tableCells}</TableRow>);
        }
      }
    }
    if (Object.keys(downStreamData).length > 0) {
      const tableColumns = Object.keys(downStreamData).length;
      const tableRows = downStreamData[Object.keys(downStreamData)[0]].length;

      for (let headerRowCount = 0; headerRowCount < tableColumns; headerRowCount++) {
        downStreamHeaderColumns.push(
          <TableCell style={{ ...cellStyle }} component="th" scope="row">
            {Object.keys(downStreamData)[headerRowCount]}
          </TableCell>
        );
      }

      for (let tableRowCount = 0; tableRowCount < tableRows; tableRowCount++) {
        const tableCells = [];

        tableCells.push(
          <TableCell align="left" style={{ ...cellStyle, backgroundColor: undefined }}>
            {downStreamData[Object.keys(downStreamData)[0]][tableRowCount].interface}
          </TableCell>
        );

        for (let i = 0; i < tableColumns; i++) {
          const rowData = downStreamData[Object.keys(downStreamData)[i]][tableRowCount];

          if (rowData !== undefined) {
            tableCells.push(
              <TableCell
                align="left"
                style={{ ...cellStyle, backgroundColor: undefined, color: rowData.color }}
              >
                {rowData.integerValue}
              </TableCell>
            );
          }
        }
        if (tableCells.length > 0) {
          downStreamTableData.push(<TableRow style={rowStyle}>{tableCells}</TableRow>);
        }
      }
    }

    return automaticTestCloseReasons.length > 0 ? (
      <>
        {automaticTestResults.map(x => {
          return (
            <>
              {x.isDocsis ? (
                <TableContainer
                  component={Paper}
                  style={{ display: 'fixed', alignItems: 'center', justifyContent: 'center' }}
                >
                  <Table className="RedResults" aria-label="simple table">
                    <TableHead style={rowStyle}>
                      <TableRow style={rowStyle}>{upStreamHeaderColumns}</TableRow>
                    </TableHead>
                    <TableBody>{upStreamTableData}</TableBody>
                    <TableHead style={rowStyle}>
                      <TableRow style={rowStyle} />
                    </TableHead>
                    <TableHead style={rowStyle}>
                      <TableRow style={rowStyle}>{downStreamHeaderColumns}</TableRow>
                    </TableHead>
                    <TableBody>{downStreamTableData}</TableBody>
                    <TableHead style={rowStyle}>
                      <TableRow style={rowStyle} />
                    </TableHead>
                    <TableBody />
                  </Table>
                </TableContainer>
              ) : (
                <TableContainer
                  component={Paper}
                  style={{ display: 'fixed', alignItems: 'center', justifyContent: 'center' }}
                >
                  <div style={{ ...cellStyle, width: '100%', height: '10px' }}>{null}</div>
                  <Table className="RedResults" aria-label="simple table">
                    <TableHead style={rowStyle}>
                      <TableRow style={rowStyle} />
                    </TableHead>
                    <TableBody>
                      {commonTestResultData !== null
                        ? commonTestResultData.map(result => (
                            <TableRow
                              style={{ ...cellStyle, backgroundColor: undefined, color: 'red' }}
                              key={result.id}
                            >
                              <TableCell
                                align="left"
                                style={{ ...cellStyle, backgroundColor: undefined, color: 'black' }}
                              >
                                {result?.name}
                              </TableCell>
                              <TableCell
                                align="left"
                                style={{ ...cellStyle, backgroundColor: undefined, color: 'red' }}
                              >
                                {result.integerValue !== null
                                  ? result.integerValue
                                  : result.stringValue}
                              </TableCell>
                            </TableRow>
                          ))
                        : null}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </>
          );
        })}
        <div id="AutomaticTestCloseReasons" className="AutomaticTestCloseReasons">
          <Paper style={{ padding: '4px' }}>
            <TextField
              label="Причина за затваряне"
              style={{ margin: '4px', marginBottom: '10px' }}
              select
              onChange={x => {
                props.handleTestReasonId(x.target.value);
                setAutomaticTestReasonId(x.target.value);
              }}
              fullWidth
              value={automaticTestReasonId}
              onClick={() => {
                document
                  .getElementById('ConfirmButton')
                  .setAttribute('class', 'MuiButtonBase-root MuiFab-root');
              }}
            >
              {automaticTestCloseReasons.map(x => (
                <MenuItem value={x.id}>{x.text}</MenuItem>
              ))}
            </TextField>
          </Paper>
        </div>
        <div
          className="AutomaticTestCloseReasons"
          style={{
            display: 'none',
            width: '100%',
          }}
        >
          <Paper style={{ padding: '4px' }}>
            <TextField
              label="Забележка"
              style={{ margin: '4px', marginBottom: '10px' }}
              value={closeNote}
              multiline
              fullWidth
              onChange={x => {
                setCloseNoteValue(x.target.value);
                props.handleCloseNote(x.target.value);
              }}
            />
          </Paper>
        </div>
      </>
    ) : (
      <></>
    );
  }
  return null;
};

export default AutomaticTestDialog;
